<style scoped>
.jobtitle {
	border-width: 1px;
	border-style: solid;
	border-color: #DADADA;
	border-radius: 5px;
	padding: 5px;
	max-width: 100%;
	margin-bottom: 10px;
}
</style>

<template>
	<div class="pa-2">
		<v-alert type="error" v-if="errormsg != ''">{{
			errormsg
		}}</v-alert>

		<v-stepper
			v-model="step"
			vertical
		>
			<v-stepper-step
				:complete="step > 1"
				step="1"
			>
				Client information
				<small v-if="step > 1">Client: {{ client.display_name }}, Contact: {{ contact.display_name }}</small>
			</v-stepper-step>
			<v-stepper-content step="1">
				<v-row no-gutters>
					<v-col cols="12" lg="6" xl="4" class="px-1 mb-2">
						<v-addressbook-dropdown
							v-model="client"
							label="Client name"
							types="1,14"
							class="mb-2"
							@on_change="client_changed"
						/>
						<v-select
							v-model="contact"
							:items="contacts"
							item-value="id"
							item-text="display_name"
							hide-details
							label="Contact name"
							return-object
							class="mb-2"
						/>
						<v-select
							v-if = "countries.length>1"
							v-model="country"
							:items="countries"
							item-value="id"
							item-text="display_name"
							hide-details
							label="Country"
							return-object
							class="mb-2"
						/>
						<v-select
							v-if = "divisions.length>1"
							v-model="division"
							:items="divisions"
							item-value="id"
							item-text="display_name"
							hide-details
							label="Division"
							return-object
							class="mb-2"
						/>
	
					</v-col>
				</v-row>
				<v-btn color="primary" @click="step = 2" :disabled="!step1_finished">Continue</v-btn>
				<!-- <v-btn text @click="step = 1" class="ml-1">Back</v-btn> -->
			</v-stepper-content>

			<v-stepper-step
				:complete="step > 2"
				step="2"
			>
				Job information
				<small v-if="step > 2">
					<span>Job title: </span>
					<span>{{ job_short }}</span>
					<span>, Job type: </span>
					<span>{{ job_type.desc }}</span>
					<span>, Job status: </span>
					<span>{{ job_status.desc }}</span>
				</small>
			</v-stepper-step>
			<v-stepper-content step="2">
				<v-row no-gutters>
					<v-col cols="12" lg="6" xl="4" class="px-1 mb-2">
						<v-text-field
							hide-details 
							label="Job title"
							v-model="job_short"
							class="mb-2"
							@change="jobshort_changed"
						>

						</v-text-field>
						<!-- Need to add job desc field here -->
						<div style="color:#CA66D2" @click="show_jobtitle=true"><u>Add a detail description...</u>
						</div>
						

						<div v-if="show_jobtitle" style="display:flex;flex-direction: column;flex-grow: 1;">
							<textarea
								placeholder="enter detail description"
								v-model="job_desc"
								class="jobtitle"
							>
								
							</textarea>
						</div>


						
						<v-select
							label="Job type"
							v-model="job_type"
							return-object
							:items="filtered_job_types"
							item-text="desc"
							item-value="id"
							hide-details
							class="mb-2"
							@click="jobtype_changed"
						>
							<template v-slot:selection="{ item, index }">
								<span>{{ item.desc }}</span>
							</template>
						</v-select>

						<v-select
							label="Job status"
							v-model="job_status"
							return-object
							:items="filtered_statusses"
							item-text="desc"
							item-value="id"
							hide-details
							
							class="mb-2"
						>
							<template v-slot:selection="{ item, index }">
								<span>{{ item.desc }}</span>
							</template>
						</v-select>
						<small v-if = "allow_specialno">Job Numbers are automatically generated. If you would like to change the job number, use the ‘special job number’ checkbox.</small>
						<v-checkbox v-if="allow_specialno" v-model="special_no" :label="'Use special job number'"
						/>
						
						<v-text-field
							v-if = "special_no"
							hide-details
							label="Job number"
							v-model="job_code"
							class="mb-1"
						>

						</v-text-field>
					</v-col>
				</v-row>
				<v-btn text @click="step = 1" class="ml-1">Back</v-btn>
				<v-btn color="primary" class="ml-1" @click="step = 3" :disabled="!step2_finished">Continue</v-btn>
				
			</v-stepper-content>

			<v-stepper-step
				:complete="step > 3"
				step="3"
			>
				Job specification
			</v-stepper-step>
			<v-stepper-content step="3">
				<!-- <v-btn color="primary" @click="Save" :disabled="!step4_finished">Continue</v-btn> -->
				<v-row no-gutters>
					<v-col cols="12" lg="6" xl="4" class="px-1 mb-2">
						<small>This is a place holder, will be adding this soon....</small>
					</v-col>
				</v-row>
				<v-btn text @click="step = 2" class="ml-1">Back</v-btn>
				<v-btn color="primary" class="ml-1" @click="step = 4" :disabled="!step3_finished">Continue</v-btn>
			</v-stepper-content>


			<v-stepper-step
				:complete="step > 4"
				step="4"
			>
				Team
				<small v-if="step > 4">
					<span>Account exec: </span>
					<span>{{ acc_exec.display_name }}</span>
					<span v-if="acc_dir.id != 0">, Acccount dir: </span>
					<span v-if="acc_dir.id != 0">{{ acc_dir.display_name }}</span>
				</small>
			</v-stepper-step>
			<v-stepper-content step="4">
				<v-row no-gutters>
					<v-col cols="12" lg="6" xl="4" class="px-1 mb-2">
						<v-addressbook-dropdown
							v-model="acc_exec"
							label="Account executive"
							types="3,12"
							class="mb-1"
							show_avatar
						/>
						<v-addressbook-dropdown
							v-model="acc_dir"
							label="Account director"
							types="3,12"
							class="mb-1"
							show_avatar
						/>
						<small >
							<span style="color:#AEBBCC">(account director is optional)</span>
						</small>
			
					</v-col>
				</v-row>
				<v-btn text @click="step = 3" class="ml-1">Back</v-btn>
				<v-btn color="primary" class="ml-1" @click="step = 5" :disabled="!step4_finished">Continue</v-btn>
				
			</v-stepper-content>

			<v-stepper-step
				:complete="step > 4"
				step="5"
			>
				Job keywords
			</v-stepper-step>
			<v-stepper-content step="5">
				<v-row no-gutters>
					<v-col cols="12" lg="6" xl="4" class="px-1 mb-2">
						<small> Will be adding keywords to this soon </small>
					</v-col>
				</v-row>
				<!-- <v-btn color="primary" @click="Save" :disabled="!step4_finished">Continue</v-btn> -->
				<v-btn text @click="step = 4" class="ml-1">Back</v-btn>
				<v-btn color="primary" class="ml-1" @click="create_job" :disabled="!can_save">Create</v-btn>
			</v-stepper-content>

		</v-stepper>
	</div>
</template>

<script>
import addressbookDropdown from "@/components/addressbook/addressbook_dropdown"
import { metaMixin } from "@/mixins/jobs/metaMixin";
export default {
	mixins: [ metaMixin ],
	data() {
		return {
			step: 1,
			errormsg: "",
			saving: false,

			client: {
				id: 0,
				display_name:'',
				allowed_jobtypes: []
			},

			contacts_loading: false,
			contact:{
				id: 0,
				code: '',
				short: ''
			},
			contacts: [],
			contact_iteration: 0,

			job_short:'',
			special_no: false,

			show_jobtitle: false,
			job_desc:'',

			job_code:'',

			job_type: { 
				id: 0,
				desc: '' ,
				is_overhead:false,
				allowed_statusses: []
			},

			job_status:{
				id:0,
				code:'',
				desc:''
			},
			acc_exec:{id:0,display_name:''},
			acc_dir:{id:0,display_name:''},
		
			country:{
				id:0,
				code:'',
				display_name:''
			},
			division:{
				id:0,
				code:'',
				display_name:'',
				is_mian:false
			}

			
		}
	},
	components: {
		'v-addressbook-dropdown': addressbookDropdown
	},

	created() {
		// add this page to our breadcrumbs
		this.$store.commit("push_breadcrumb", {
			exact: true,
			text: "Create New Job",
			to: this.$route.path
		});
		this.load_meta_data();
	},
	computed: {

		step1_finished() {
			if (!this.client.hasOwnProperty("id")){
				//no client at all
				return false;
			} else if (!this.contact.hasOwnProperty("id")){
				// no contact
				return false;
			} else if (this.client.id != 0 && this.contact.id != 0){
				return true;

			}
			///not done yet
			return false;
			// return true;
		},
		step2_finished(){
			if (this.job_short == ''){
				return false;
			} else if (!this.job_type.hasOwnProperty("id")){
				return false;
			} else if (!this.job_status.hasOwnProperty("id")){
				return false;
			} else if (this.job_type.id == 0){
				return false;
			} else if (this.job_status.id == 0){
				return false;
			} else {
				return true;
			}
			//not doen yet
			return false;
		},
		allow_specialno(){

			if (this.job_type.is_overhead) {
				return false;
			} else if (this.can_enterjobno){
				return true;
			}

			return false;
		},
		step3_finished(){
			return true;
		},
		step4_finished(){
			if (!this.acc_exec.hasOwnProperty("id")){
				return false;
			
			} else if (this.acc_exec.id == 0){
				return false;

			} else {
				return true;
			}
			//not doen yet
			return false;
		},
		can_save() {
			if (this.saving) {
				// we are already saving so..
				return false
			// } else if () {
			// 	// nneed to add keyword check
			// 	return false
			}

			// TODO add more checks to prevent saving before we are ready

			return true;
		},

		filtered_job_types() {
			if (this.client.allowed_jobtypes == null) {
				return this.job_types;
			} else {
				let filtered = [];

				filtered = this.job_types.filter(jobtype => {
					return this.client.allowed_jobtypes.indexOf(jobtype.id) != -1;
				});

				return filtered;
			}
		},
		filtered_statusses(){
			let filtered = [];

			filtered = this.statusses.filter(jobstatus => {
				if (jobstatus.group == 3) {
					// can't create a completed job
					return false;
				} else if (jobstatus.group == 4) {
					// can't create a cancelled job
					return false;
				} else if (jobstatus.group == 5) {
					// can't create a dead job
					return false;
				} else if (!this.job_type.id){
					// if we don't have a job type, we don't do further filtering
					return true;
				} else if (this.job_type.allowed_statusses == null) {
					// if we don't have allowed statusses all are allowed
					return true;
				} else {
					// only return allowed statusses
					return this.job_type.allowed_statusses.indexOf(jobstatus.id) != -1;
				}
			});

			return filtered;
		}
		
	},
	methods:{
		jobshort_changed(){
			if (this.job_desc==''){
				this.job_desc=this.job_short;
			}
		},
		jobtype_changed() {
			if (this.job_type.is_overhead) {
				this.special_no = false;
				this.job_code = '';
			}

		},
		client_changed() {
			let self = this
			this.errormsg = '';

			// reset these
			this.contacts_loading = true;
			this.contacts = [];
			this.contact = {
				id: 0,
				code: '',
				short: ''
			};
			this.contact_iteration += 1;

			
			this.division = {
				id:0,
				code:'',
				display_name:'',
				is_headoffice: false
			};
			
			this.country = {
				id:0,
				code:'',
				display_name:'',
				is_main: false
			};

			this.acc_exec = {
				id: 0,
				display_name :''

			};

			this.acc_dir = {
				id: 0,
				display_name :''

			};
			
			let iteration = this.contact_iteration;

			// now get our phase and task info
			
			let url = "/api/addressbook/" + this.client.id + "/contacts";
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					if (iteration == self.contact_iteration) {
						// this is the result of the last search we've started, lets process it.
						let json = d.data;

						// For some reason axios isn't always converting our data
						if ((typeof json) == "string") {
							json = JSON.parse(json);
						}

						if (json.status == "OK") {
							// console.log("got data");

							self.contacts = json.data;

							if (self.contacts.length > 0) {
								self.contact = self.contacts[0];
							}
							//copy country and division
							if (self.countries.length > 0){
								self.country = self.client.country;
							}
							if (self.divisions.length > 0){
								self.division = self.client.client_division;
							}

							/* disabled for now because this does not display properly, once fixed we should enable this..
							if (self.client.acc_exec) {
								self.acc_exec.id = self.client.acc_exec.id;
								self.acc_exec.display_name = self.client.acc_exec.display_name;

							}

							if (self.client.acc_dir) {
								self.acc_dir.id = self.client.acc_dir.id;
								self.acc_dir.display_name = self.client.acc_dir.display_name;

							}
							*/

						} else {
							self.errormsg = json.reason;
							console.log(json.reason);
						}
					}
				})
				.catch(function(e) {
					if (iteration == self.contact_iteration) {
						// this is the error for the last search we've started, lets show it.
						self.errormsg = e.message;
						console.log(e);
					}
				})
				.finally(function() {
					if (iteration == self.contact_iteration) {
						self.contacts_loading = false;
					}
				});	

		},
		create_job(){
			let self = this;
			this.saving = true;
			this.errormsg = '';

			let url = "/api/jobs";

			axios
				.post(url, {
					type_id: self.job_type.id,
					status_id: self.job_status.id,
					special_number: self.special_no ? self.job_code : null,
					description: self.job_desc,
					short_desc: self.job_short,
					client_id: self.client.id,
					acc_exec_id: self.acc_exec.id,
					acc_dir_id: self.acc_dir.id > 0 ? self.acc_dir.id : null,
					contact_id: self.contact.id > 0 ? self.contact.id : null,
					country_id: self.country.id,
					division_id: self.division.id,
					// master_job_id: null,
					// is_out_of_scope: false,
					is_export_job: false,
					billing_cycle: 0,
				}, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						self.$router.push({ name: "View Job", params: {id: json.data.id }});
					} else {
						self.errormsg = json.reason;
					}
				})
				.catch(function(e) {
					self.errormsg = e.message;
					console.log(e);
				})
				.finally(function() {
					self.saving = false;
				})
		},

	},

}
</script>
